// Combined Full SAT Mock Exam: 98 questions (54 R&W + 44 Math)
// Section 1: Reading & Writing (Questions 1-54)
// Section 2: Math (Questions 55-98)

import { mockExamQuestions } from '../../mock-exam/data/mockExamQuestions';
import { mockExamRWQuestions } from '../../mock-exam-rw/data/mockExamRWQuestions';

export interface FullMockQuestion {
  id: number;
  section: 'rw' | 'math';
  domain: string;
  subtopic: string;
  passage?: string;
  question: string;
  options: { label: string; value: string }[];
  correctAnswer: string;
  solution: {
    steps: string[];
    explanation: string;
  };
}

// Convert R&W questions (1-54) with section tag
const rwQuestions: FullMockQuestion[] = mockExamRWQuestions.map((q) => ({
  id: q.id,
  section: 'rw' as const,
  domain: q.domain,
  subtopic: q.subtopic,
  passage: q.passage,
  question: q.question,
  options: q.options,
  correctAnswer: q.correctAnswer,
  solution: q.solution,
}));

// Convert Math questions (55-98) with section tag and renumbered IDs
const mathQuestions: FullMockQuestion[] = mockExamQuestions.map((q, index) => ({
  id: 55 + index, // Start from question 55
  section: 'math' as const,
  domain: q.domain,
  subtopic: q.subtopic,
  question: q.question,
  options: q.options,
  correctAnswer: q.correctAnswer,
  solution: q.solution,
}));

// Combined array: R&W (1-54) + Math (55-98)
export const fullMockExamQuestions: FullMockQuestion[] = [
  ...rwQuestions,
  ...mathQuestions,
];

// Domain color mapping for both sections
export const FULL_EXAM_DOMAIN_COLORS: Record<string, string> = {
  // R&W domains
  'Information & Ideas': 'violet',
  'Craft & Structure': 'rose',
  'Expression of Ideas': 'amber',
  'Standard English Conventions': 'teal',
  // Math domains
  'Algebra': 'emerald',
  'Advanced Math': 'sky',
  'Problem-Solving & Data Analysis': 'cyan',
  'Geometry & Trigonometry': 'orange',
};

// Question counts by domain
export const FULL_EXAM_DOMAIN_COUNTS: Record<string, number> = {
  'Information & Ideas': 14,
  'Craft & Structure': 14,
  'Expression of Ideas': 13,
  'Standard English Conventions': 13,
  'Algebra': 11,
  'Advanced Math': 11,
  'Problem-Solving & Data Analysis': 11,
  'Geometry & Trigonometry': 11,
};

// Section metadata
export const SECTION_METADATA = {
  rw: {
    name: 'Reading & Writing',
    questionCount: 54,
    timeMinutes: 64,
    questionRange: { start: 1, end: 54 },
  },
  math: {
    name: 'Math',
    questionCount: 44,
    timeMinutes: 70,
    questionRange: { start: 55, end: 98 },
  },
};

export const TOTAL_TIME_MINUTES = 134;
export const TOTAL_QUESTIONS = 98;